import { FC } from 'react'
import styled from 'styled-components'
import Skeleton from '@app.components/Skeleton'

const OpenGraphPreviewLoading: FC = () => {
  return (
    <StyledWrapper>
      <Skeleton width={350} height={16} />
      <Skeleton width={200} height={16} className="gap" />
      <Skeleton width={80} height={13} className="bottom" />
    </StyledWrapper>
  )
}

export default OpenGraphPreviewLoading

const StyledWrapper = styled.div`
  padding: 20px;
  background-color: #f5fafd;

  & .gap {
    margin-top: 6px;
  }

  & .bottom {
    margin-top: 20px;
  }
`
